var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBuildingLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 12.6667H15.3334V14H0.666748V12.6667H2.00008V2.66667C2.00008 2.29848 2.29856 2 2.66675 2H9.33341C9.70161 2 10.0001 2.29848 10.0001 2.66667V12.6667H12.6667V7.33333H11.3334V6H13.3334C13.7016 6 14.0001 6.29848 14.0001 6.66667V12.6667ZM3.33341 3.33333V12.6667H8.66675V3.33333H3.33341ZM4.66675 7.33333H7.33341V8.66667H4.66675V7.33333ZM4.66675 4.66667H7.33341V6H4.66675V4.66667Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBuildingLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/building-line.6a43fdd5.svg";
export { ForwardRef as ReactComponent };